import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TranslationHtml from '../TranslationHtml/TranslationHtml';
import './CookieBar.scss';
import { useCookieConsent } from '../../hooks/useCookieConsent';
import { CookiePreferencesModal } from '../Modals/CookiePreferencesModal/CookiePreferencesModal';

interface CookieBarProps {
  gaAccount: string;
}

export const CookieBar = ({ gaAccount }: CookieBarProps) => {
  const { t } = useTranslation();
  const { analyticsEnabled, handleAccept, handleDecline } = useCookieConsent(gaAccount);
  const [isPreferencesModalOpen, setIsPreferencesModalOpen] = useState(false);
  const [isAnalyticsToggleOn, setIsAnalyticsToggleOn] = useState(analyticsEnabled);

  // Seed the toggle from the current cookie state here, at the point the modal is opened,
  // rather than resyncing it with an effect inside the (always-mounted) modal.
  const openPreferencesModal = () => {
    setIsAnalyticsToggleOn(analyticsEnabled);
    setIsPreferencesModalOpen(true);
  };

  const handleSavePreferences = () => {
    if (isAnalyticsToggleOn) {
      handleAccept();
    } else {
      handleDecline();
    }
    setIsPreferencesModalOpen(false);
  };

  const handleEnableAllFromPreferences = () => {
    setIsAnalyticsToggleOn(true);
    handleAccept();
    setIsPreferencesModalOpen(false);
  };

  return (
    <div className="ew-cookie-bar ew-cookie-bar--show-bottom ew-cookie-bar--animate">
      <div className="ew-cookie-bar__container">
        <div className="ew-cookie-bar__cookie-message-body">
          <TranslationHtml htmlString={t('cookiebar.messageHtml')} />
        </div>
        <div className="ew-cookie-bar__cookie-button-body">
          <button
            className="ew-cookie-bar__button ew-cookie-bar__button--preferences"
            onClick={openPreferencesModal}
          >
            <TranslationHtml htmlString={t('cookiebar.buttonPreferencesText')} />
          </button>
          <button
            className="ew-cookie-bar__button ew-cookie-bar__button--decline"
            onClick={handleDecline}
          >
            <TranslationHtml htmlString={t('cookiebar.buttonDeclineText')} />
          </button>
          <button
            className="ew-cookie-bar__button ew-cookie-bar__button--accept"
            onClick={handleAccept}
          >
            <TranslationHtml htmlString={t('cookiebar.buttonAcceptText')} />
          </button>
        </div>
      </div>
      <CookiePreferencesModal
        isOpen={isPreferencesModalOpen}
        handleCloseModal={() => setIsPreferencesModalOpen(false)}
        isAnalyticsOn={isAnalyticsToggleOn}
        onToggleAnalytics={setIsAnalyticsToggleOn}
        onEnableAll={handleEnableAllFromPreferences}
        onSave={handleSavePreferences}
      />
    </div>
  );
};
